<div class="d-flex align-items-start justify-content-between text-white shadow-card bg-danger light-rounded px-3 py-4 alert-toast-container"
     [class.bg-primary]="toastPackage.toastType === 'toast-success'"
     [class.bg-danger]="toastPackage.toastType === 'toast-error'">
  <div class="nunito">
    {{message}}
  </div>
  <div (click)="hide()" class="d-flex ml-3 pointer">
    <i class="fa-solid fa-xmark"></i>
  </div>
</div>
